import { IResponse } from '~/services/api/types';
import { IRole, IUser } from '~/store/user/types';
import { privateAxios, publicAxios } from '../requestsCollection';
import {
  IAuth,
  IChangePasswordData,
  ILoginData,
  ILoginTeamsData,
  IRefreshTokenParams,
  ISendbirdData,
  ISignUpData,
  IUpdateUser,
} from './types';

export const validateEmail = (data: { email: string }): IResponse<void> =>
  publicAxios({
    method: 'post',
    url: 'Account/validate-signup-email',
    data,
  });

export const validateCode = (data: { email: string; code: string }): IResponse<void> =>
  publicAxios({
    method: 'post',
    url: 'Account/validate-signup-code',
    data,
  });

export const resetPasswordEmail = (data: { email: string }): IResponse<void> =>
  publicAxios({
    method: 'post',
    url: 'Account/send-reset-password-code',
    data,
  });

export const changePassword = (data: IChangePasswordData): IResponse<void> =>
  publicAxios({
    method: 'post',
    url: 'Account/change-password',
    data,
  });

export const validateRessetPasswordCode = (data: {
  email: string;
  code: string;
}): IResponse<void> =>
  publicAxios({
    method: 'post',
    url: 'Account/validate-reset-password-code',
    data,
  });

export const resetPassword = (data: ISignUpData): IResponse<void> =>
  publicAxios({
    method: 'post',
    url: 'Account/reset-password',
    data,
  });

export const signUp = (data: ISignUpData): IResponse<void> =>
  publicAxios({
    method: 'post',
    url: 'Account/signup',
    data,
  });

export const login = (data: ILoginData): IResponse<IAuth> =>
  publicAxios(
    {
      method: 'post',
      url: 'Auth/login',
      data: { ...data, client: 'Web' },
    },
    'v3/',
  );

export const loginTeams = (data: ILoginTeamsData): IResponse<{ roles: IRole[] }> =>
  publicAxios(
    {
      method: 'post',
      url: 'Auth/login-teams',
      data: { ...data, client: 'Web' },
    },
    'v3/',
  );

export const getCurrentUser = (): IResponse<IUser> =>
  privateAxios(
    {
      method: 'get',
      url: 'Account/profile',
    },
    'v3/',
  );

export const updateCurrentUser = (data: IUpdateUser): IResponse<void> =>
  privateAxios({
    method: 'post',
    url: 'Account/profile',
    data,
  });

export const refreshToken = (data: IRefreshTokenParams): IResponse<IAuth> =>
  publicAxios(
    {
      method: 'post',
      url: 'Auth/refresh',
      data,
    },
    'v3/',
  );

export const fetchSendbirdToken = (): IResponse<ISendbirdData> =>
  privateAxios({
    method: 'get',
    url: 'sendbird/token',
  });
